/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 9.045,
    height: 8.603,
    viewBox: '0 0 9.045 8.603',
    data: '<path pid="0" d="M0 3.283l2.261 2.208-.533 3.112 2.794-1.472 2.795 1.472-.534-3.112 2.262-2.208-3.127-.45L4.522 0 3.123 2.833z"/>'
  }
})
